import {createSelector} from 'reselect';
import get from 'lodash/get';

const skillSelector = state => state.skills;

export const getSkills = createSelector(
  [skillSelector],
  skills => get(skills, 'skills', {})
);
